import {CopyToClipboard} from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

require('highlight.js/styles/srcery.css')
const React = require('react')
const PropTypes = require('prop-types')
const hljs = window.hljs

class CodeBlock extends React.PureComponent {
  constructor(props) {
    super(props)
    
    this.state={
      copied:false
    }
  }

  

  componentDidMount() {
    this.highlightCode()
  }

  componentDidUpdate() {
    //console.log(this.setRef.innerHTML ,this.props.value)
    this.highlightCode()
  }

  highlightCode() {
    hljs&&hljs.highlightBlock(this.setRef)
  }
  copy=(e)=>{
    //console.log(this.props.value)
    document.execCommand(this.props.value);
//     var Url2=this.ref;//获取文本框id

// 　　　　Url2.select(); // 选择对象用户定义的代码区域

// 　　　　document.execCommand("Copy"); //原生copy方法执行浏览器复制命令
  }


  allmark=()=>{
    
    if(this.pre.className.indexOf("code-block-fullscreen")>=0){
      document.querySelector(".headerbox").style.display='flex'
      document.documentElement.style.overflow="auto"
      document.body.style.overflow="auto"
      this.setRef.style.height="revert"
      this.pre.classList.remove("code-block-fullscreen")
    }else{
      this.setRef.style.height="100%"
      document.documentElement.style.overflow="hidden"//禁止浏览器滚动 PC端
      
      document.body.setAttribute('style','overflowY:hidden;overflow:hidden;')//禁止浏览器滚动 移动端

      document.querySelector(".headerbox").style.display='none'
      this.pre.classList.add("code-block-fullscreen")
      // document.documentElement.style.overflow="hidden"
    }
    
  }

  render() {
    return (
      <pre ref={(ref)=>this.pre=ref} className="highlight-wrap">
        <i className="point" onClick={this.allmark}/>
        <code ref={ref=>this.setRef=ref} className={"hljs "+`${this.props.className}`} style={{overflow:"auto"}}>
          {this.props.value}
        </code>
        <CopyToClipboard 
        className="copy-code"
        text={this.props.value}
          onCopy={() => this.setState({copied: true},()=>toast.success("复制成功"))}>
        <a >
          {
            this.state.copied?
            <i className="fe fe-intersect" aria-hidden="true"></i>
            :
            <i className="fe fe-difference" aria-hidden="true"></i>
          }
          </a>
          </CopyToClipboard>
      </pre>
    )
  }
}

CodeBlock.defaultProps = {
  language: ''
}

CodeBlock.propTypes = {
  value: PropTypes.string.isRequired,
  language: PropTypes.string
}

export default CodeBlock